import { LitElement, html, customElement, property, css, query } from "lit-element";

@customElement("oc-modal")
export default class OcModal extends LitElement {
    @property({ attribute: true, type: Boolean }) isOpen = false;

    @query("#content")
    content!: HTMLDivElement;

    @query("#modal")
    modalElement!: HTMLDivElement;

    static get styles() {
        return css`
            #modal {
                position: fixed; /* Stay in place */
                z-index: 1; /* Sit on top */
                left: 0;
                top: 0;
                width: 100%; /* Full width */
                height: 100%; /* Full height */
                overflow: auto; /* Enable scroll if needed */
                background-color: rgb(0, 0, 0); /* Fallback color */
                background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
            }

            .modal-content {
                background-color: #fefefe;
                margin: 15% auto; /* 15% from the top and centered */
                /* padding: 20px; */
                border: 1px solid #888;
                width: 30%; /* Could be more or less, depending on screen size */
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .heading {
                border-bottom: 1px solid lightgray;
            }

            .heading_content {
                padding: 30px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .footer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .content {
                align-self: center;
                text-align: center;
            }

            /* The Close Button */
            .close {
                color: #aaa;
                font-size: 28px;
                font-weight: bold;
                cursor: pointer;
                align-self: flex-end;
            }

            #heading {
                align-self: center;
            }

            .placeholder {
                width: 16px;
            }
        `;
    }

    render() {
        if (this.isOpen) {
            return html`
                <div id="modal">
                    <!-- Modal content -->
                    <div class="modal-content">
                        <div class="heading">
                            <div class="heading_content">
                                <div class="placeholder"></div>
                                <slot id="heading" name="heading">&nbsp;</slot>
                                <span class="close" @click=${this.close}>&times;</span>
                            </div>
                        </div>
                        <div id="content" class="content">
                            <slot name="content">&nbsp;</slot>
                        </div>
                        <div class="footer">
                            <slot name="footer">&nbsp;</slot>
                        </div>
                    </div>
                </div>
            `;
        }

        return "";
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    firstUpdated() {
        window.onclick = (event: MouseEvent) => {
            if (event.composedPath() && event.composedPath()[0]) {
                if (event.composedPath()[0] == this.modalElement) {
                    this.close();
                }
            }
        };
    }
}
